import React from "react";
import { LeftSidebar } from "@/components/ui/sidebar";
import LeftSidebarContent from "./sidebar/left-sidebar-content";
import useAuthStore from "@/store/use-auth-store";

/**
 * Sol sidebar. Sağ panel artık `@/features/chat-dock` (ChatDock) —
 * buradaki boş RightSidebar placeholder'ı kaldırıldı.
 */
export const AppSidebar: React.FC = () => {
  const { isAuthenticated } = useAuthStore();

  // 🔓 Public mod: guest kullanıcıda sidebar tamamen gizlenir (kolon dahil).
  // Login/register aksiyonları header üzerinden sunuluyor.
  if (!isAuthenticated()) {
    return null;
  }

  return (
    <LeftSidebar>
      <LeftSidebarContent />
    </LeftSidebar>
  );
};
